import {ILevelMapAggregatedTile, ILevelMapTileProgress, TileType} from "../../types";
import {call, fork, put, take} from "redux-saga/effects";
import {getTileBonusAction, isBonusAction} from "../../../player/types";
import {showBonusAwardDialog} from "../../../dialog-manager/dialogs/showBonusAwardDialog";
import {closeDialog} from "../../../dialog-manager/actions";
import {addScore} from "../../../player/actions";

export function* changePlayerStats(tileProgress: ILevelMapTileProgress, tile: ILevelMapAggregatedTile) {
    if (tileProgress.bonus) {
        const source= tile.isBonusQuestion
            ? "got_question_bonus"
            : tile.tileType === TileType.CardsGame
                ? "successful_cards_bonus_game"
                : tile.tileType === TileType.ChestGame
                    ? "successful_chests_bonus_game"
                    : undefined;

        const bonusAction = yield call(getTileBonusAction, tileProgress.bonus, tileProgress.id, source);

        const count = isBonusAction(bonusAction)
            ? bonusAction.payload.count
            : bonusAction.payload;
        yield fork(showBonusAwardDialog, { bonus: tileProgress.bonus, count: count });
        yield take(closeDialog);

        yield put(bonusAction);
    }

    const score = tileProgress.score || 0;
    if (score > 0) {
        const source= tile.tileType === TileType.SimpleQuestion || tile.tileType === TileType.Exit
            ? "answered_question_right"
            : undefined;

        yield put(addScore(score, source));
    }
}